<template>
    <div class="underlying-child-content">
        <div class="line"></div>
        <el-table :data="tabledata" class="a-mt-10">
            <el-table-column label="广告名称" prop="name"></el-table-column>
            <el-table-column label="广告编码" prop="adLocationId"></el-table-column>
            <el-table-column label="广告平台" prop="endDate">
                <template slot-scope="{ row }">
                    {{ row.appId | initDic(appidListDic) }}
                </template>
            </el-table-column>
            <el-table-column label="状态" prop="showType">
                <template slot-scope="{ row }">
                    {{ row.showType | initDic(statusDic) }}
                </template>
            </el-table-column>
            <el-table-column label="重新开启时间" prop="restartTime"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import util from '@/utils/util'
    export default {
        data() {
            return {
                util: util,
                statusDic: [
                    {
                        label: '开启',
                        value: '1'
                    },
                    {
                        label: '关闭',
                        value: '0'
                    }
                ],
                appidListDic: [
                    {
                        label: '毛豆充（微信小程序）',
                        value: 'hichar.user.wxapp'
                    },
                    {
                        label: '毛豆充（支付宝小程序）',
                        value: 'hichar.user.aliapp'
                    },
                    {
                        label: '玖电毛豆充（云闪付小程序）',
                        value: 'hichar.user.unapp'
                    },
                    {
                        label: '安心e充（微信小程序）',
                        value: 'hichar.user.rest.wxapp'
                    },
                    {
                        label: '智慧e充（微信小程序）',
                        value: 'hichar.user.black.wxapp'
                    }
                ]
            }
        },
        props:['tabledata'],
        mounted () {
        },
        methods:{
        }
    }
</script>

<style lang="scss" scoped>
.underlying-child-content{
    padding: 10px 20px 20px;
    position: relative;
    .line{
        height: 10px;
        background: #f5f7fa;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }
}
</style>